export default __webpack_public_path__ + "08400e62a923d03144c66372893eb11f.svg";